/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { TicketEditService } from '../../ticket-edit.service';
import { PlanState } from 'src/app/services/plan-state.service';
import { UntypedFormBuilder } from '@angular/forms';

import { TicketEditComponent, setupFormForMilestone } from '../ticket-edit.component';
import { ConstraintAcceptanceService } from 'src/app/modules/ticket-edit/constraint-acceptance.service';
import { PlanAccessCheck } from 'src/app/services/PlanAccessCheck';
import { FeatureFlagManager } from 'src/app/services/FeatureFlagManager';

import * as appStrings from '@touchplan/strings';

@Component({
	selector: 'milestone-edit',
	templateUrl: './milestone-edit.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MilestoneEditComponent extends TicketEditComponent {
	public appStrings = appStrings;

	constructor(
		public planState: PlanState,
		public ticketEditService: TicketEditService,
		protected formBuilder: UntypedFormBuilder,
		protected cd: ChangeDetectorRef,
		protected constraintAcceptanceService: ConstraintAcceptanceService,
		protected planAccessCheck: PlanAccessCheck,
		protected featureFlagManager: FeatureFlagManager
	) {
		super(
			ticketEditService,
			formBuilder,
			planState,
			cd,
			constraintAcceptanceService,
			planAccessCheck,
			featureFlagManager
		);
		setupFormForMilestone(this.editForm);
	}
}
